import React from "react";
import { ButtonProps as MuiButtonProps } from "@mui/material";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import {
  ButtonHiddenLabel,
  ButtonSize,
  ButtonSpinnerIcon,
  ButtonSpinnerWrapper,
  StyledButton,
} from "./Button.styles";
import { ColorPalette } from "../../../theme";

export interface ButtonProps extends Omit<MuiButtonProps, "children"> {
  label: string;
  onClick: () => void;
  size: ButtonSize;
  backgroundColor?: keyof ColorPalette;
  borderColor?: keyof ColorPalette;
  textColor?: keyof ColorPalette;
  reverse?: boolean;
  testId?: string;
  startIcon?: React.ReactNode;
  loading?: boolean;
}

export const Button = (props: ButtonProps): React.ReactElement => (
  <StyledButton
    data-testid={props.testId}
    id={props.id}
    className={props.className}
    aria-busy={props.loading || undefined}
    aria-label={props.loading ? props.label : props["aria-label"]}
    disabled={props.disabled || props.loading}
    fullWidth={props.fullWidth}
    size={props.size}
    onClick={props.onClick}
    $backgroundColor={props.backgroundColor}
    $textColor={props.textColor}
    $reverse={props.reverse}
    $borderColor={props.borderColor}
    startIcon={props.loading ? undefined : props.startIcon}
  >
    {props.loading ? (
      <>
        <ButtonHiddenLabel>{props.label}</ButtonHiddenLabel>
        <ButtonSpinnerWrapper>
          <ButtonSpinnerIcon icon={faSpinner} spin />
        </ButtonSpinnerWrapper>
      </>
    ) : (
      props.label
    )}
  </StyledButton>
);
